import { MouseEvent, memo } from 'react';
import { CapabilityMapContentContainer } from '@ardoq/graph';
import { LayoutBox } from './LayoutBox';
import { Zoomable } from 'atomicComponents/Zoomable/Zoomable';
import { ViewIds } from '@ardoq/api-types';
import { getComponentIdFromTarget } from './utils';
import { dispatchAction } from '@ardoq/rxbeach';
import { hoveredComponentChanged } from 'tabview/actions';
import { LayoutBoxType } from './types';
import { GRID_WIDTH } from './consts';
import type { I18nLocale } from '@ardoq/i18n';

const VIEW_ID = ViewIds.CAPABILITY_MAP;

const onMouseOver = (event: MouseEvent) => {
  const componentId = getComponentIdFromTarget(event);
  dispatchAction(hoveredComponentChanged(componentId || null), VIEW_ID);
};
const onMouseLeave = () => {
  dispatchAction(hoveredComponentChanged(null), VIEW_ID);
};

type CapabilityMapProps = {
  rootLayoutBox: LayoutBoxType;
  onClick: (event: MouseEvent) => void;
  onDoubleClick: (event: MouseEvent) => void;
  onMouseDown: (event: MouseEvent) => void;
  hoveredComponentId: string | null;
  focusedComponentId: string | null;
  i18nLocale: I18nLocale;
};
const CapabilityMap = memo(
  ({
    rootLayoutBox,
    onClick,
    onDoubleClick,
    onMouseDown,
    hoveredComponentId,
    focusedComponentId,
    i18nLocale,
  }: CapabilityMapProps) => {
    const style = {
      width: `${
        Math.max(
          rootLayoutBox.calculatedGridWidth,
          rootLayoutBox.targetGridWidth
        ) * GRID_WIDTH
      }px`,
    };

    return (
      <Zoomable viewId={VIEW_ID} i18nLocale={i18nLocale}>
        <CapabilityMapContentContainer
          style={style}
          onMouseOver={onMouseOver}
          onMouseLeave={onMouseLeave}
          onClick={onClick}
          onDoubleClick={onDoubleClick}
          onMouseDown={onMouseDown}
          className="react-view"
        >
          <LayoutBox
            layoutBox={rootLayoutBox}
            hoveredComponentId={hoveredComponentId}
            focusedComponentId={focusedComponentId}
          />
        </CapabilityMapContentContainer>
      </Zoomable>
    );
  }
);

export { CapabilityMap };
